import React from 'react';
import PropTypes from 'prop-types';
import Banner from '../Banner';
import { connect } from 'react-redux';

export const NIVA_HEADER = 'Time is running out';
const SEARCH_TRACKING_PARAM =
    '?utm_source=eventbrite&utm_medium=banner&utm_campaign=search';
const HOME_TRACKING_PARAM =
    '?utm_source=eventbrite&utm_medium=banner&utm_campaign=home';

const trackNIVAHeaderClick = (category) => ({
    type: 'TRACK_NIVA_BANNER_CLICK',
    meta: {
        analytics: {
            action: 'NivaBannerClick',
            category,
        },
    },
});

export const verifyNIVADomain = (domain) => {
    return domain.endsWith('.com');
};

const shouldBannerRender = (props) => {
    if (verifyNIVADomain(props.domain)) {
        return true;
    }

    return false;
};

const getCategory = (isSearch, isAuthenticated) => {
    if (isSearch) {
        return 'search';
    }

    if (isAuthenticated) {
        return 'home';
    }

    return 'home-feed';
};

const NIVABanner = (props) => {
    const shouldRender = shouldBannerRender(props);

    if (!shouldRender) {
        return null;
    }

    const GA_CATEGORY = getCategory(props.isSearch, props.isAuthenticated);

    const trackingParams = props.isSearch
        ? SEARCH_TRACKING_PARAM
        : HOME_TRACKING_PARAM;

    return (
        <Banner leftAccentColor="#F05537" style="dark" header={NIVA_HEADER}>
            <span>
                Join the movement to keep independent venues alive.{' '}
                <a
                    onClick={() => {
                        props.handleTracking(GA_CATEGORY);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://www.nivassoc.org/take-action${trackingParams}`}
                >
                    Send a message to Congress
                </a>{' '}
                to #SaveOurStages.
            </span>
        </Banner>
    );
};

NIVABanner.propTypes = {
    isSearch: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    handleTracking: PropTypes.func,
};

const _mapStateToProps = (state) => ({
    domain: state.app.domain,
    isSearch: !!state.auth,
    isAuthenticated: state.auth
        ? state.auth.isAuthenticated
        : state.user.isAuthenticated,
});

const _mapDispatchToProps = (dispatch) => ({
    handleTracking: (...args) => dispatch(trackNIVAHeaderClick(...args)),
});

export default connect(_mapStateToProps, _mapDispatchToProps)(NIVABanner);
